var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Edit Reward ")]),_c('RewardFrom',{attrs:{"reward":_vm.reward,"type":"UPDATE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }